<template>
  <div id="about-page">
    <Navigation />
    <Team-Enterprise />
    <FooterSection />
  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue'
import TeamEnterprise from '@/components/Team-Enterprise.vue'
import FooterSection from '@/components/FooterSection.vue'

export default {
  name: 'AboutPage',
  components: {
    Navigation,
    'Team-Enterprise': TeamEnterprise,
    FooterSection
  },
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>

<style scoped>
#about-page {
  width: 100%;
  background: #0B1220;
}
</style>
